import React from "react";
import { motion } from "framer-motion";

const benefits = [
  { n: "01", h: "World-class degrees", d: "French universities are internationally recognised and rank among Europe's most respected." },
  { n: "02", h: "A fraction of the cost", d: "Public tuition starts around €2,895 per year, dramatically less than most U.S. universities." },
  { n: "03", h: "Safe, vibrant student cities", d: "Paris, Lyon, Bordeaux, Toulouse, Nice: rich culture, walkable neighbourhoods, world-class food." },
  { n: "04", h: "Cross-Europe travel access", d: "Weekend trips to London, Barcelona, Rome, and Berlin, all reachable by train." },
  { n: "05", h: "Long-term life opportunity", d: "Path to internships, career networks, and residency options after graduation." },
];

export default function WhyStudyFrance() {
  return (
    <section className="bg-white py-24 md:py-32" data-testid="why-study-france">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-8">
          <span className="rule-gold" /><span className="eyebrow">Why France</span>
        </div>
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <h2 className="md:col-span-7 serif text-5xl md:text-6xl leading-[0.98] tracking-tight text-[#0d1b3e]">
            World-class education at a <em className="italic text-[#b8892b]">fraction of U.S. costs</em>.
          </h2>
          <p className="md:col-span-5 text-lg text-[#4a5570] leading-relaxed">
            Five reasons American families keep choosing France over the private-college pressure cooker back home.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-5 gap-4">
          {benefits.map((b, i) => (
            <motion.div
              key={b.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="border-t border-[#0d1b3e]/15 pt-6"
              data-testid={`why-france-benefit-${b.n}`}
            >
              <div className="chapter-num !text-[#b8892b] text-4xl">{b.n}</div>
              <h3 className="serif text-xl text-[#0d1b3e] mt-4 leading-tight">{b.h}</h3>
              <p className="text-sm text-[#4a5570] mt-2 leading-relaxed">{b.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
